import React from 'react';
import { Modal, Tag, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ALL_HOTKEYS, HotkeyDef, HotkeyGroup } from '../constants/hotkeys';

const { Text } = Typography;

interface HotkeyHelpModalProps {
  open: boolean;
  onClose: () => void;
}

const HotkeyRow: React.FC<{ def: HotkeyDef }> = ({ def }) => {
  const { t } = useTranslation('table');
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0' }}>
      <Text>{t(def.descriptionKey)}</Text>
      <Tag style={{ fontFamily: 'monospace', marginInlineEnd: 0 }}>{def.label}</Tag>
    </div>
  );
};

const groups: HotkeyGroup[] = ['status', 'actions', 'navigation'];

export const HotkeyHelpModal: React.FC<HotkeyHelpModalProps> = ({ open, onClose }) => {
  const { t } = useTranslation('table');
  return (
    <Modal
      title={t('hotkeys.modalTitle')}
      open={open}
      onCancel={onClose}
      footer={null}
      width={960}
    >
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 24, paddingTop: 8 }}>
        {groups.map((group) => (
          <div key={group}>
            <Text strong style={{ display: 'block', marginBottom: 8 }}>
              {t(`hotkeys.groups.${group}`)}
            </Text>
            <Space direction="vertical" style={{ width: '100%' }} size={2}>
              {ALL_HOTKEYS.filter((h) => h.group === group).map((h) => (
                <HotkeyRow key={h.sequence} def={h} />
              ))}
            </Space>
          </div>
        ))}
      </div>
    </Modal>
  );
};
